import type { Actions, State } from '../state'
import type { Dispatch } from 'react'
import { createContext } from 'react'

type TActivityTypesContext = [
  state: State,
  dispatch: Dispatch<Actions | Promise<Actions>>,
]

export const ActivityTypesContext = createContext<
  TActivityTypesContext | undefined
>(undefined)
